import React, { FC } from 'react';
import { Icon } from '@silverfort/sf-components';

interface Props {
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
    title: string;
}

const PageHeader: FC<Props> = ({ icon, title }) => {
    return (
        <div className="pl-6 h-16 w-full shadow-sf-small flex items-center gap-2 flex-none">
            <Icon icon={icon} className="text-sf-gray-400" size={24} />
            <div className="font-medium text-lg font-sf-poppins">{title}</div>
        </div>
    );
};

export default PageHeader;
